import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import ApplicantList from './pages/ApplicantList';
import ApplicantDetail from './pages/ApplicantDetail';
import Calendar from './pages/Calendar';
import NeedsAttention from './pages/NeedsAttention';
import Settings from './pages/Settings';
import Apply from './pages/Apply';

function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-surface-subtle">
        <Routes>
          {/* Public routes */}
          <Route path="/apply" element={<Apply />} />
          <Route path="/login" element={<Login />} />

          {/* Protected routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <ApplicantList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/applicants/:id"
            element={
              <ProtectedRoute>
                <ApplicantDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/calendar"
            element={
              <ProtectedRoute>
                <Calendar />
              </ProtectedRoute>
            }
          />
          <Route
            path="/needs-attention"
            element={
              <ProtectedRoute>
                <NeedsAttention />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/import"
            element={
              <ProtectedRoute adminOnly>
                <Settings />
              </ProtectedRoute>
            }
          />

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </AuthProvider>
  );
}

export default App;
